import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, MessageSquareIcon, SearchIcon, PlusIcon } from 'lucide-react';
import { cases } from '../data/mockCases';
import { agencies } from '../data/mockAgencies';
const tabs = ['案例分享', '机构广场'] as const;
export function Community() {
  const nav = useNavigate();
  const [tab, setTab] = useState<(typeof tabs)[number]>('案例分享');
  return <div className="bg-slate-50 min-h-screen pb-20 relative" data-id="element-393">
      <div className="bg-white sticky top-0 z-20 border-b border-slate-100" data-id="element-394">
        <div className="px-4 pt-3 pb-2 flex items-center gap-4" data-id="element-395">
          {tabs.map(t => <button key={t} onClick={() => setTab(t)} className={`relative pb-1.5 text-base ${tab === t ? 'text-slate-900 font-extrabold' : 'text-slate-500'}`} data-id="element-396">
              {t}
              {tab === t && <motion.div layoutId="comm-tab" className="absolute -bottom-px left-0 right-0 h-0.5 bg-blue-600 rounded" data-id="element-397" />}
            </button>)}
          <div className="ml-auto" data-id="element-398">
            <SearchIcon size={18} className="text-slate-600" data-id="element-399" />
          </div>
        </div>
      </div>

      <AnimatePresence mode="wait" data-id="element-400">
        <motion.div key={tab} initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} data-id="element-401">
          {tab === '案例分享' ? <CaseList data-id="element-402" /> : <AgencyList data-id="element-403" />}
        </motion.div>
      </AnimatePresence>

      {tab === '案例分享' && <button onClick={() => nav('/community/cases/publish')} className="fixed bottom-20 right-4 w-12 h-12 rounded-full bg-blue-600 text-white flex items-center justify-center shadow-lg z-30 active:scale-95 transition" style={{
      boxShadow: '0 4px 14px rgba(43,110,245,0.4)'
    }} aria-label="发布案例" data-id="element-404">
          <PlusIcon size={24} data-id="element-405" />
        </button>}
    </div>;
}
function ChipFilters({
  groups
}: {
  groups: {
    label: string;
    opts: string[];
  }[];
}) {
  const [sel, setSel] = useState<Record<string, string>>({});
  return <div className="bg-white px-4 py-3 space-y-2" data-id="element-406">
      {groups.map(g => <div key={g.label} className="flex items-center gap-2 text-xs" data-id="element-407">
          <div className="text-slate-500 w-12 shrink-0" data-id="element-408">{g.label}</div>
          <div className="flex gap-2 flex-wrap" data-id="element-409">
            {g.opts.map(o => {
          const active = sel[g.label] === o;
          return <button key={o} onClick={() => setSel({
            ...sel,
            [g.label]: active ? '' : o
          })} className={`px-2.5 py-1 rounded-full ${active ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-700'}`} data-id="element-410">
                  {o}
                </button>;
        })}
          </div>
        </div>)}
    </div>;
}
function CaseList() {
  const nav = useNavigate();
  return <>
      <ChipFilters groups={[{
      label: '国家',
      opts: ['英国', '美国', '中国香港', '新加坡']
    }, {
      label: '专业',
      opts: ['计算机', '商科', '工程', '艺术']
    }, {
      label: '学历',
      opts: ['本科', '硕士', '博士']
    }]} data-id="element-411" />
      <div className="px-3 pt-3 space-y-2.5" data-id="element-412">
        {cases.map(c => <button key={c.id} onClick={() => nav(`/community/cases/${c.id}`)} className="w-full bg-white rounded-2xl p-4 text-left active:bg-slate-50" data-id="element-413">
            <div className="flex items-center gap-3" data-id="element-414">
              <img src={c.avatar} alt="" className="w-11 h-11 rounded-full object-cover bg-slate-100" data-id="element-415" />
              <div className="flex-1 min-w-0" data-id="element-416">
                <div className="font-bold text-slate-800 text-sm" data-id="element-417">
                  {c.name} · {c.major} · 成功录取
                </div>
                <div className="text-[11px] text-slate-500 mt-0.5" data-id="element-418">
                  {c.bgSchool} · {c.bgGpa} · {c.bgLang}
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-1 mt-2.5" data-id="element-419">
              {c.offers.map(o => <span key={o} className="text-[11px] bg-blue-50 text-blue-600 px-2 py-0.5 rounded" data-id="element-420">
                  🎓 {o}
                </span>)}
            </div>
          </button>)}
      </div>
    </>;
}
function AgencyList() {
  const nav = useNavigate();
  return <>
      <ChipFilters groups={[{
      label: '地区',
      opts: ['北京', '上海', '南京', '广州']
    }, {
      label: '规模',
      opts: ['大型', '中型', '小型']
    }, {
      label: '擅长',
      opts: ['英港新', '美研', '艺术']
    }]} data-id="element-421" />
      <div className="px-3 pt-3 space-y-2.5" data-id="element-422">
        {agencies.map(a => <button key={a.id} onClick={() => nav(`/community/agencies/${a.id}`)} className="w-full bg-white rounded-2xl p-4 text-left active:bg-slate-50 flex gap-3" data-id="element-423">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center text-white font-bold text-lg shrink-0" style={{
          background: a.logoBg
        }} data-id="element-424">
              {a.logoText}
            </div>
            <div className="flex-1 min-w-0" data-id="element-425">
              <div className="font-bold text-slate-800 text-sm" data-id="element-426">{a.name}</div>
              <div className="flex flex-wrap gap-1 mt-1" data-id="element-427">
                {a.strong.map(t => <span key={t} className="text-[10px] bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded" data-id="element-428">
                    {t}
                  </span>)}
              </div>
              <div className="flex items-center gap-3 mt-1.5 text-[11px] text-slate-500" data-id="element-429">
                <span className="flex items-center gap-0.5 text-amber-600 font-semibold" data-id="element-430">
                  <StarIcon size={11} fill="currentColor" data-id="element-431" /> {a.rating}
                </span>
                <span data-id="element-432">
                  <MessageSquareIcon size={11} className="inline mr-0.5" data-id="element-433" />
                  {a.cases.toLocaleString()} 服务案例
                </span>
              </div>
            </div>
          </button>)}
      </div>
    </>;
}